<template>
  <div class="registry-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">
      <div class="top-state">
        <el-steps align-center :active="activeModule" finish-status="success">
          <el-step title="填写账号信息"></el-step>
          <el-step title="注册成功"></el-step>
        </el-steps>
      </div>

      <div class="registry-box">
        <!-- 表单部分 -->
        <div v-if="activeModule === 0">
          <div class="title">请填写您的账号信息</div>

          <el-form ref="registerForm" :model="registerForm" :rules="registerRules">
            <el-form-item prop="phone">
              <el-input placeholder="请填写手机号" @input="mobileOnlyNumber" v-model.trim="registerForm.phone"></el-input>
            </el-form-item>

            <el-form-item class="img-code-item">
              <el-input
                v-model.trim="imageCheckCode"
                placeholder="请填写图形验证码"
                :validate-event="false"
              />

              <div class="img-box" @click="reGetQrCodeHandle">
                <img class="img-common" :src="qrCodeImgUrl" />
              </div>
            </el-form-item>

            <el-form-item class="code-item" prop="checkCode">
              <el-input
                v-model.trim="registerForm.checkCode"
                @input="codeOnlyNumber"
                placeholder="请填写验证码"
              />

              <el-button type="primary" @click="sendcodeHandle" :disabled="codeDisabled">
                <span v-if="!codeDisabled">发送验证码</span>

                <span v-if="codeDisabled">{{codeTime}}s</span>
              </el-button>

            </el-form-item>

            <el-form-item prop="password">
              <el-input placeholder="设置您的登录密码" type="password" v-model.trim="registerForm.password"></el-input>
            </el-form-item>

            <el-form-item prop="confirmPassword">
              <el-input placeholder="再次输入登录密码" type="password" v-model.trim="registerForm.confirmPassword"></el-input>
            </el-form-item>

            <el-form-item prop="email">
              <el-input placeholder="输入您的邮箱（选填）" v-model.trim="registerForm.email"></el-input>
            </el-form-item>

            <el-form-item prop="name">
              <el-input placeholder="姓名" v-model.trim="registerForm.name"></el-input>
            </el-form-item>

            <el-form-item prop="pid">
              <el-select class="companySelect" @change="provinceChange" v-model="registerForm.pid" placeholder="学校所在省份">
                <el-option
                  v-for="item in provinceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="city_id">
              <el-select class="companySelect" @change="cityChange" v-model="registerForm.city_id" placeholder="学校所在市区">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="area_id">
              <el-select class="companySelect" @change="areaChange" v-model="registerForm.area_id"  placeholder="学校所在行政区">
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="companyId">
              <el-select class="companySelect" v-model="registerForm.companyId" placeholder="所在学校">
                <el-option
                  v-for="item in schoolList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>

            </el-form-item>

            <el-form-item prop="position">
              <el-input placeholder="担任职务" v-model.trim="registerForm.position"></el-input>
            </el-form-item>


            <div class="read-item flex items-center">
              <el-checkbox v-model="checkedReadme"></el-checkbox>
              <div class="check-text flex">
                <div class="text">阅读</div>
                <div @click="$router.push({name: 'help'})" class="link">《网站注册服务条款》</div>
              </div>
            </div>
              
            <el-form-item>
              <el-button class="submit-btn" :loading="loading" type="primary" @click="userSubmit">同意协议并注册</el-button>
              <div class="login-tip" @click="$router.push({name: 'login'})">已有账号？去登录</div>
            </el-form-item>

          </el-form>
        </div>

        <!-- 状态 -->
        <div v-if="activeModule === 1" class="registry-success">
          <div class="icon mx-auto"></div>

          <div class="text">恭喜你注册成功！</div>

          <div class="login" @click="$router.push({name: 'login'})">去登录</div>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isMobile } from '@/utils/index'
import { registryFetch, sendCode } from '@/api/login'
import { fetchSchoolList, fetchAreaList } from '@/api/common'
import { maxCodeTime } from '@/config/index'
import jsSHA from "jssha"
import imgQrCodeMixins from '@/mixins/imgQrCode'

const checkMobile = (rule, value, callback) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    return callback(new Error('您输入的手机号不合法'))
  }

  callback()
}
const checkCode = (rule, value, callback) => {
  if (!(/^\d{6}$/.test(value))) {
    return callback(new Error('您输入的验证码不合法'))
  }

  callback()
}
const checkEmail = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }

  if (!(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(value))) {
    return callback(new Error('您输入的邮箱不合法'))
  }

  callback()
}

export default {
  mixins: [imgQrCodeMixins],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    
    return {
      checkedReadme: false,

      activeModule: 0,

      // 验证码倒计时
      codeTimer: null,
      codeTime: maxCodeTime,
      codeDisabled: false,

      registerForm: {
        phone: "",
        checkCode: '',
        password: '',
        confirmPassword: '',

        email: '',

        name: '',

        pid: '',
        city_id: '',
        area_id: '',
        companyId: "",

        position: ""
      },
      registerRules: {
        phone: [
          { required: true, message: '手机号为必填项', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],

        checkCode: [
          { required: true, message: '验证码为必填项', trigger: 'blur' },
          { validator: checkCode, trigger: 'blur' }
        ],

        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],

        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],

        pid: [
          // { required: true, message: '省份为必填项', trigger: 'blur' }
        ],
        city_id: [
          // { required: true, message: '市区为必填项', trigger: 'blur' }
        ],
        area_id: [
          // { required: true, message: '行政区为必填项', trigger: 'blur' }
        ],

        name: [
          { required: true, message: '姓名为必填项', trigger: 'blur' },
          { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        ],
        companyId: [
          // { required: true, message: '职位为必填项', trigger: 'blur' },
          // { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        ],
        position: [
          // { required: true, message: '职位为必填项', trigger: 'blur' },
          // { max: 100, message: '长度不得超过100个字符', trigger: 'blur' }
        ]
      },

      provinceList: [],  // 省份
      cityList: [],  // 市区
      regionList: [], // 行政区
      schoolList: [],

      loading: false
    }
  },
  mounted() {

  },
  methods: {
    isMobile,
    codeOnlyNumber(value) {
      this.registerForm.checkCode = value.replace(/[^\d]/g, ""); 
    },
    mobileOnlyNumber(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, ""); 
    },

    sendcodeHandle() { // 点击发送验证码
      this.$refs['registerForm'].validateField('phone', async errMsg => {
        if (!errMsg) { // 手机号验证成功
          
          if (!this.imageCheckCode) {
            this.$message.error('请填写图形验证码')
            return
          }

          try {
            this.codeDisabled = true

            await sendCode({
              mobile: this.registerForm.phone,
              code: this.code, // 随机数验证码
              imageCheckCode: this.imageCheckCode
            })

            this.$message.success('发送验证码成功')

            this.codeTimer = setInterval(() => {
              if (this.codeTime === 0) {
                clearInterval(this.codeTimer)

                this.codeTime = maxCodeTime
                this.codeDisabled = false
              } else {
                this.codeTime = this.codeTime - 1
              }
            }, 1000)
          } catch (error) {
            this.codeDisabled = false
          }
        }
      })
    },

    async getAreaList() {
      try {
        this.provinceList = await fetchAreaList()
      } catch (error) {
        console.log(error)
      }
    },

    async provinceChange(e) { // 省变化
      try {
        // 处理市
        this.cityList = await fetchAreaList({
          pid: e
        })

        this.registerForm.city_id = ''

        // 清空行政区
        this.regionList = []
        // 清空学校
        this.schoolList = []
        this.registerForm.area_id = ''
        this.registerForm.companyId = ''
      } catch (error) {
        console.log(error)
      }
    },
    async cityChange(e) { // 市变化
      try {
        // 处理行政区
        this.regionList = await fetchAreaList({
          pid: e
        })

        this.registerForm.area_id = ''

        // 清空学校
        this.schoolList = []
        this.registerForm.companyId = ''
      } catch (error) {
        console.log(error)
      }
    },
    async areaChange(e) {
      this.schoolList = await fetchSchoolList({
        page: 0,
        pageSize: 50,
        type: 2,
        pid: this.registerForm.pid,
        city_id: this.registerForm.city_id,
        area_id: this.registerForm.area_id
      })

      this.registerForm.companyId = ''
    },

    userSubmit() { // 编辑提交
      if (!this.checkedReadme) {
        this.$message.error('未同意《网站注册服务条款》')
        return
      }

      this.$refs['registerForm'].validate(async valid => {
        if (valid) {
          this.loading = true

          // 加密
          const shaObj1 = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" })
          const shaObj2 = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" })
          shaObj1.update(this.registerForm.password)
          shaObj2.update(this.registerForm.confirmPassword)

          let params = {
            ...this.registerForm,
            nickName: this.registerForm.phone,
            password: shaObj1.getHash("HEX"),
            confirmPassword: shaObj2.getHash("HEX"),
            type: 1
          }

          delete params.phone
          delete params.pid
          delete params.city_id
          delete params.area_id

          try {
            await registryFetch(params)

            this.loading = false

            this.activeModule = 1
          } catch (error) {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
  },
  created() {
    this.getAreaList()
  },
  destroyed() {
    clearInterval(this.codeTimer)
  }
}
</script>

<style lang="scss">
.registry-container {
  background: $bg;

  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;

      .top-state {
        width: 100%;
      }

      .registry-box {
        padding: 4rem 1.5rem;
      }
    }
  }

  .code-item {
    margin-bottom: 22px;
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }

    .el-button {
      width: 110px;
      margin-left: 10px;
    }
  }

  .img-code-item {
    margin-bottom: 22px;
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }

    .img-box {
      cursor: pointer;
      width: 176px;
      height: 40px;
      margin-left: 10px;
      border: 1px solid #F4F7FC;
    }
  }

  .sys-max-width {
    padding: 49px 60px 71px;

    .top-state {
      width: 400px;
      margin: 0 auto 29px;

      .el-steps {
        .el-step__head.is-process, .el-step__head.is-success {
          .el-step__icon.is-text {
            background-color: $success;
            border-color: $success;
          }

          .el-step__icon-inner {
            color: #fff;
          }
        }

        .el-step__main {
          .el-step__title {
            font-weight: normal;
            color: #B2B7C0;
            font-size: 14px;

            &.is-process {
              color: #596270;
            }
          }
        }
      }
    }

    .registry-box {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
      border-radius: 10px;

      padding: 56px 296px 50px;

      .title {
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #596270;
        line-height: 24px;
        margin-bottom: 44px;
      }

      .read-item {
        margin-bottom: 37px;

        .text {
          color: #333;
        }

        .link {
          cursor: pointer;
          color: $primary;
        }

        .check-text {
          margin-left: 11px;
        }

        
      }

      .submit-btn {
        width: 100%;
      }

      .login-tip {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #596270;
        line-height: 24px;
        margin-top: 29px;
        cursor: pointer;
      }

      .registry-success {

        padding: 60px 0;
        text-align: center;
        .icon {
          width: 56px;
          height: 56px;
          margin-bottom: 30px;
          background: url(~@/assets/success-icon.png) no-repeat;
          background-size: 100% 100%;
        }

        .text {
          font-size: 20px;
          font-weight: 400;
          color: #596270;
          line-height: 24px;
          margin-bottom: 15px;
        }

        .login {
          font-size: 14px;
          font-weight: 400;
          color: $primary;
          line-height: 24px;
          cursor: pointer;
        }
      }

      .companySelect {
        width: 100%;
      }
    }
  }
}
</style>
